export default __webpack_public_path__ + "static/media/InsideMuscles_08.22ee2c51.png";